import update from 'immutability-helper';

import { createReducer } from 'shared/utils/redux';
import { loadingStates, setLoadingStates } from 'shared/constants/redux';
import { createRequestTypes } from 'shared/utils/request';

export const DEVICES_FETCH_LIST = createRequestTypes('devices/FETCH_LIST');

export const fetchDevices = () => ({
  type: DEVICES_FETCH_LIST.REQUEST,
  payload: {}
});

const initState = {
  states: loadingStates,
  data: [],
  response: null
};

export default createReducer(initState, {
  [DEVICES_FETCH_LIST.REQUEST]: state => {
    return update(state, {
      $merge: {
        states: setLoadingStates({ isLoading: true })
      }
    });
  },
  [DEVICES_FETCH_LIST.SUCCESS]: (state, action) => {
    return update(state, {
      $merge: {
        states: setLoadingStates({ isLoaded: true }),
        data: action.payload
      }
    });
  },
  [DEVICES_FETCH_LIST.FAILURE]: (state, action) => {
    return update(state, {
      $merge: {
        states: setLoadingStates({ hasError: true }),
        response: action.payload.response
      }
    });
  }
});
